import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { getConfig } from '../routing';

export function buildRoutes(user, onBreadcrumbs) {
    const nodes = getLeafs(getConfig().children);
    const routes = nodes.filter(({ access }) => {
        if (access) {
            return access.type === 'change'
                ? user.canChange(access.permission)
                : user.canView(access.permission);
        }
        return true;
    });
    const redirect = routes.length ? routes[0].url : '/forbidden';
    routes.push({
        type: 'redirect',
        url: '/',
        redirect,
    });
    return routes.map(route => {
        const type = route.type || 'match';
        return ROUTE_TYPES[type](route, onBreadcrumbs);
    });
}

function getLeafs(nodes) {
    return nodes.reduce((leafs, node) => {
        if (node.url) {
            leafs.push(node);
        }
        if (node.children && node.children.length) {
            leafs = leafs.concat(getLeafs(node.children));
        }
        return leafs;
    }, []);
}

const ROUTE_TYPES = {
    match: ({ url, component: Component, extra = {} }, onBreadcrumbs) => (
        <Route
            key={url}
            path={url}
            render={props => {
                return (
                    <Component
                        {...props}
                        {...extra}
                        updateBreadcrumbs={onBreadcrumbs}
                    />
                );
            }}
            exact
        />
    ),
    redirect: ({ url, redirect }) => (
        <Redirect key={`${url}::${redirect}`} from={url} to={redirect} exact />
    ),
};
